import { action, makeAutoObservable, makeObservable, observable, values } from "mobx"
import DataLoading from "react-sdk/DataLoading"
import Texts from "react-sdk/Texts"

import { clamp, getUrlVar, removeUrlVar } from "react-sdk/utils"
// import SoundPlayer from "react-sdk/SoundPlayer";
import Config from "react-sdk/Config"
import ScaleManager from "react-sdk/ScaleManager"

import SequencesManager from "react-sdk/haxelibs/SequencesManager"
import SoundPlayer from "react-sdk/SoundPlayer"
import Analytics from "react-sdk/Vertx/Analytics"

import Dials from "./Dials"
import Minigames from "./Minigames/Minigames"
import ReaxeAPI from "./ReaxeAPI"
import SequenceScenario from "./SequenceScenario"
import PopupsManager from "react-sdk/PopupsManager"
import Notifications from "react-sdk/Notifications/Notifications"

import ObjectiveFile from "react-sdk/Objectives/ObjectiveFile"
import SaveGame from "./SaveGame"
import Catalogue from "./Catalogue/Catalogue"
import Chronometre from "./Chronometre"
import ScormAdapter from "react-sdk/ScormAdapter"
import Ftues from "./Ftues"


const VertxClient = window.gms.VertxClient

// NOTE je fais ça pour tester, ca serait bien de pouvoir générer ça en auto...
/**
 * @typedef VertxClientDef
 * @type {object}
 * @property {object} UserData
 * @property {function} UserData.getUniverse
 * @property {function} UserData.getPseudo
 * @property {function} UserData.getUserMail
 * @property {function} UserData.getUserID
 */

export const SCREENS = {
  LOADING: "LOADING",
  HOME: "HOME",
  MODULES: "MODULES",
  WELCOME: "WELCOME",
  VIDEO: "VIDEO",
  GAME: "GAME",
  TEST_MG: "TEST_MG",
  ECRAN_FINAL: "ECRAN_FINAL",
}

export const POPUPS = {
  MENTIONS_LEGALES: "MENTIONS_LEGALES",
  NOTIF: "NOTIF",
  MINIGAME_STARS : "MINIGAME_STARS",
  MODULE_STARS : "MODULE_STARS",
  CATALOGUE_ITEM: "CATALOGUE_ITEM",
  CATALOGUE: "CATALOGUE",
  MINIGAME_INTRO:"MINIGAME_INTRO",
  FTUE:"FTUE"
}

class AppState {
  debugMode = false
  skipDial = false
  skipCatalog = false
  skipAct = false
  test_mg_mode = false

  language = "fr"
  screen = SCREENS.LOADING

  connected = false

  /** @type {ReaxeAPI} */
  reaxe_api = null

  haxeCanvas = null
  haxeBackendVisible = false

  /** @type {ScormAdapter} */
  scorm = null

  moduleDebriefText = null
  moduleDebriefOnClose = null

  module2ToUnlock = false
  module3ToUnlock = false

  /**
   * Objet qui contient, pour chaque module, un objet avec le nombre d'étoile (int 0 à 3) + les mgs référencés dans ce module (tableau d'ids de mg)
   */
  lastModuleResults = {
    module1 : { stars : null, mgIds : null },
    module2 : { stars : null, mgIds : null },
    module3 : { stars : null, mgIds : null }
  }
  /**
   * Objet qui contient les meilleurs scores (nombre d'étoile) d'entrainement + le score d'évaluation pour chaque module
   */
  moduleStars = {
    module1 : {training : null, evaluation : null},
    module2 : {training : null, evaluation : null},
    module3 : {training : null, evaluation : null}
  }

  UI_visibilities = {}
  lockHud = false // HACK

  /** @type {ObjectiveFile} */
  objectives = null

  currentModule = null
  isEvaluation = false
  
  constructor() {
    this.debugMode = getUrlVar("debug") !== null
    this.skipAct = getUrlVar("skipAct") !== null
    this.skipDial = getUrlVar("skipDial") !== null
    this.skipCatalog = getUrlVar("skipCat") !== null

    this.test_mg_mode = getUrlVar("test_mg") !== null

    /*let h = window.innerHeight
    let w = window.innerWidth
    let finalH = 1920
    let finalW = (w * finalH) / h
    finalW = clamp(850, 1200, finalW)*/
    let finalW = 1920
    let finalH = 1080

    ScaleManager.init(finalW, finalH)

    SequencesManager.variables.verbose = false

    let requiredFiles = window.CONFIG.requiredFiles;
    DataLoading.getAllFiles(requiredFiles, "")
      .then(files => {
        Config.init(files.config)

        this.reaxe_api = new ReaxeAPI()
        this.haxeCanvas = document.createElement("canvas")

        Texts.init(files.texts, this.language)
        this.dials = new Dials(this.skipDial)
        this.dials.addDialFile(requiredFiles.dials)

        //this.soloObjectives = new ObjectiveFile(requiredFiles.objectives)
        Catalogue.init(files.catalogue)
        SoundPlayer.init(files.audio)

        Minigames.init(
          requiredFiles.minigames,
          files
        )
        Ftues.init(files.ftues)

        this.objectives = new ObjectiveFile(window.CONFIG.requiredFiles.objectives)
        SequenceScenario.init()
        SequenceScenario.addFile(requiredFiles.sequences)
      })
      .then(() => {

        window.lime.embed(
          "backend-haxe",
          this.haxeCanvas,
          ScaleManager.w,
          ScaleManager.h,
          {
            parameters: {
              logLevel: Config.get("haxe_loglevel"),
              reaxe_api: this.reaxe_api.api,
              app:
              {
                display: { // dans notre cas, ça setup la taille du level
                  width: 1280,
                  height: 720
                },
                script: {
                  projectFile:"data/game.scp"
                }
              }
            },
          }
        )
      })
      .then(() => {
        this.scorm = new ScormAdapter()
        if(this.debugMode) this.scorm.api.showLog = true
        this.scorm.addQuitListener()
        if (this.scorm.api) {
          let objCount = this.scorm.getValue("cmi.objectives._count")
          if (objCount == 0) {
            this.scorm.setValue("cmi.completion_status", "not attempted")
            this.scorm.setValue("cmi.success_status", "unknown") 
            this.scorm.setValue("cmi.score.min", 0)
            this.scorm.setValue("cmi.score.max", 9)

            this.scorm.setValue("cmi.objectives.0.id", "1")
            this.scorm.setValue("cmi.objectives.0.description", "Niveau débutant")
            this.scorm.setValue("cmi.objectives.0.completion_status", "not attempted")
            this.scorm.setValue("cmi.objectives.0.success_status", "unknown") 
            this.scorm.setValue("cmi.objectives.0.score.min", 0)
            this.scorm.setValue("cmi.objectives.0.score.max", 3)

            this.scorm.setValue("cmi.objectives.1.id", "2")
            this.scorm.setValue("cmi.objectives.1.description", "Niveau intermédiaire")
            this.scorm.setValue("cmi.objectives.1.completion_status", "not attempted")
            this.scorm.setValue("cmi.objectives.1.success_status", "unknown") 
            this.scorm.setValue("cmi.objectives.1.score.min", 0)
            this.scorm.setValue("cmi.objectives.1.score.max", 3)

            this.scorm.setValue("cmi.objectives.2.id", "3")
            this.scorm.setValue("cmi.objectives.2.description", "Niveau expert")
            this.scorm.setValue("cmi.objectives.2.completion_status", "not attempted")
            this.scorm.setValue("cmi.objectives.2.success_status", "unknown") 
            this.scorm.setValue("cmi.objectives.2.score.min", 0)
            this.scorm.setValue("cmi.objectives.2.score.max", 3)
          }
        }
      })


    makeAutoObservable(this, {
      reaxe_api: false,
      haxeCanvas: false,
    })
  }
  launchModule(id, isEvaluation) {
    this.currentModule = id
    this.isEvaluation = isEvaluation

    this.setScreen(SCREENS.LOADING)
    Chronometre.start()
    this.reaxe_api.toHaxe("game", "triggerScript", { trigger : "Standard", triggerValue : "LoadModule-" + id})
  }

  showEndScreen() {
    this.currentModule = null
    Chronometre.pause()
    Chronometre.reset()
    this.setScreen(SCREENS.ECRAN_FINAL);

    this.reaxe_api.toHaxe("game", "triggerScript", { trigger : "Standard", triggerValue : "UnloadModule"})
  }


  goBackToModulesChoiceScreen() {
    this.currentModule = null
    Chronometre.pause()
    Chronometre.reset()
    this.setScreen(SCREENS.MODULES);

    this.reaxe_api.toHaxe("game", "triggerScript", { trigger : "Standard", triggerValue : "UnloadModule"})
  }

  initCharacters() {
    // pas besoin du charEngine comme on n'utilise que des persos animate
    // window.SpeechAPI.waitCharacterEngine(false)
    //window.SpeechAPI.setLogLevel(Config.get("speechapi_loglevel"))

    return new Promise(resolve => {
      window.SpeechAPI.initCharacters(
        window.CONFIG.requiredFiles.characters,
        () => {
          console.log("initCharacters done")
          window.SpeechAPI.loadCharacterIds(["chef_chantier"], () => {
            console.log("loadCharacterIds done")

            resolve()

          })
        }
      )
    })
  }


  setScreen(id) {
    Analytics.changeScreenEvents(this.screen, id)
    this.screen = id
  }

  computeModuleResult(mgIds) {
    
    let moduleMgs = mgIds.map(mgId => Minigames.get(mgId))
    let starNb = 0
    if (moduleMgs)
      starNb = Math.round(moduleMgs.reduce((total, mg) => total + mg.getStars(), 0) / moduleMgs.length)

    let key = "module" + this.currentModule
    let lastResult = { stars : starNb, mgIds : mgIds }
    this.lastModuleResults[key] = lastResult;

    let currentModuleStars = this.moduleStars[key];
    if (!this.isEvaluation) {
      if (currentModuleStars.training == null) {// on flag l'unlock du module suivant
        if (this.currentModule == 1)
          this.module2ToUnlock = true
        else if (this.currentModule == 2)
          this.module3ToUnlock = true
      }

      if (currentModuleStars.training == null || currentModuleStars.training < starNb)
        currentModuleStars.training = starNb;
    } else {
      currentModuleStars.evaluation = starNb;

      if (this.scorm.api) {
        const scormObjIndex = this.currentModule - 1
        this.scorm.setValue("cmi.objectives." + scormObjIndex + ".score.raw", starNb)
        this.scorm.setValue("cmi.objectives." + scormObjIndex + ".score.scaled", starNb == 3 ? 1 : starNb / 3)
        this.scorm.setValue("cmi.objectives." + scormObjIndex + ".completion_status", "completed")
        this.scorm.setValue("cmi.objectives." + scormObjIndex + ".success_status", "passed")
        //this.scorm.setValue("cmi.objectives." + scormObjIndex + ".success_status", starNb > 1 ? "passed" : "failed")

        if (this.currentModule == 3) {
          let totalStarNb = this.moduleStars.module1.evaluation + this.moduleStars.module2.evaluation + this.moduleStars.module3.evaluation
          this.scorm.setValue("cmi.score.raw", totalStarNb)
          this.scorm.setValue("cmi.score.scaled", totalStarNb == 9 ? 1 : totalStarNb / 9)
          this.scorm.setValue("cmi.progress_measure", 1)
          this.scorm.setValue("cmi.completion_status", "completed")
          this.scorm.setValue("cmi.success_status", "passed")
        } else {
          this.scorm.setValue("cmi.progress_measure", this.currentModule / 3)
          this.scorm.setValue("cmi.completion_status", "incomplete")
        }
      }

    }
  }

  getLastModuleResult(id) {
    let key = "module" + id;
    return this.lastModuleResults[key];
  }

  onBackendReady() {

    this.reaxe_api.registerModule("game", (event, params, done) => {

      if (event == "GameLoaded") {
        this.initCharacters().then(() => {
          this.setScreen(SCREENS.HOME)
          this.haxeBackendVisible = true
        })
      }
      else if (event == "ModuleLoaded") {
        this.setScreen(SCREENS.GAME)
      }

      done()
    })
  }

}

export default new AppState()
